import moment from 'moment';

export default {
  name: 'Record',
  props: {
    record: {
      type: Object
    },
    type: {
      type: String
    },
    position: {
      type: Number
    },
    scheduleData: {
      type: Object
    },
    section: {
      type: String
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      left: 0,
      row_entry_symbol: 'h',
      td_width: 41,
      is_being_dragged: false
    }
  },
  computed: {
    posTop () {
      return (this.position * 40) + 4;
    },
    width () {
      const days = Math.ceil(this.record.minutes_worked / 1440);
      return 36 * days + ((days - 1) * 5);
    },
    color () {
      if (!this.team || !this.record.user_id) {
        return '';
      }
      let sameTeam = false;
      for (const user of this.team.users) {
        if (user.user_id == this.record.user_id) {
          sameTeam = true;
          break;
        }
      }
      if (sameTeam) {
        return '';
      }
      return 'background-color:' + this.team.color_hex;
    },
    schedule () {
      for (const key in this.scheduleData.schedules) {
        if (this.scheduleData.schedules[key].id == this.record.schedule_id) {
          return this.scheduleData.schedules[key];
        }
      }
    },
    companyId () {
      return this.$store.getters.getParamFromConfig('company_departments', this.schedule.department_id, 'company_id');
    },
    shift () {
      for (const key in this.scheduleData.shifts) {
        if (this.scheduleData.shifts[key].id == this.record.shift_id) {
          return this.scheduleData.shifts[key];
        }
      }
    },
    team () {
      if (this.shift && this.shift.team_id) {
        for (const key in this.scheduleData.teams) {
          if (this.scheduleData.teams[key].id == this.shift.team_id) {
            return this.scheduleData.teams[key];
          }
        }
      }
    },
    editable () {
      return this.section !== 'list-my' && this.schedule.status != 'confirmed';
    },
    tooltip () {
      if (this.is_being_dragged) {
        return null;
      }
      const startDate = moment(this.record.datetime_start);
      const toDate = moment(this.record.datetime_end);

      const out = [];
      out.push(this.$t('work-schedule.worktime') + ': ' + startDate.format('HH:mm') + ' - ' + toDate.format('HH:mm'));

      if (this.shift) {
        out.push(this.$t('work-schedule.shift') + ': ' + this.shift.name + (this.shift.abbreviation ? ' (' + this.shift.abbreviation + ')' : ''));
      }

      if (this.record.events.length) {
        out.push(this.$t('work-schedule.events') + ':');
        for (const rowEvent of this.record.events) {
          out.push(rowEvent.event.name + ': ' + this.minutesToHours(rowEvent.minutes));
        }
      }

      if (this.record.notes) {
        out.push(this.$t('work-schedule.schedule-notes') + ': ' + this.record.notes);
      }

      return out.join('<br>');
    },
    showAlert () {
      let result = false;

      if (this.record.notes) {
        result = true;
      }

      if (this.record.events.length) {
        for (const rowEvent of this.record.events) {
          const name = rowEvent.event.system_name;
          if (name === 'delay' || name === 'downtime') {
            result = true;
            break;
          }
        }
      }

      return result;
    },
    showNightHours () {
      return this.record.night_minutes > 0;
    },
    tdWidth () {
      return this.$store.state.hr.ezLayoutSettings.tdWidth;
    }
  },
  methods: {
    minutesToHours (num) {
      if (this.row_entry_symbol !== 'h') {
        return '1d';
      } else {
        const hours = Math.floor(num / 60);
        const minutes = num % 60;

        return hours + 'h ' + (minutes ? minutes + '' : '');
      }
    },
    calculatePosition () {
      const firstDay = document.getElementById('table-' + this.schedule.department_id + '-' + this.schedule.division_id).getElementsByClassName('first-day');

      if (!firstDay.length) { return; }

      const monthStart = moment(this.scheduleData.days[Object.keys(this.scheduleData.days)[0]].sql_day);
      let recordStart = moment(this.record.datetime_start);

      if (recordStart < monthStart) {
        recordStart = monthStart;
      }

      this.left = firstDay[0].offsetLeft - (this.tdWidth - 1) + recordStart.toDate().getDate() * this.tdWidth;
    },
    editRecord: function () {
      this.$emit('editRecord', this.record);
    },
    dragStart: function (event) {
      this.is_being_dragged = true;
      const startDate = moment(this.record.datetime_start);
      const fields = document.getElementsByClassName('accept-drop-' + this.companyId + '-' + this.schedule.department_id + '-' + this.schedule.division_id + '-' + this.type + '-' + startDate.format('YYYY-MM-DD'));

      for (const key in fields) {
        if (fields[key].classList) {
          fields[key].style.backgroundColor = '#fbf6b6';
        }
      }

      event.dataTransfer.setData('record-id', this.record.id);
      event.dataTransfer.setData('record-type', this.type);
      event.dataTransfer.setData('record-company-id', this.companyId);
    },
    dragEnd: function (event) {
      this.is_being_dragged = false;
      const startDate = moment(this.record.datetime_start);
      let fields = document.getElementsByClassName('over-drop');

      for (const key in fields) {
        if (fields[key].classList) {
          fields[key].classList.remove('over-drop');
        }
      }

      fields = document.getElementsByClassName('accept-drop-' + this.companyId + '-' + this.schedule.department_id + '-' + this.schedule.division_id + '-' + this.type + '-' + startDate.format('YYYY-MM-DD'));

      for (const key in fields) {
        if (fields[key].classList) {
          fields[key].style.backgroundColor = '';
        }
      }
    },
    getRowEntrySymbol () {
      const symbols = this.$store.getters.getConfigOptions('ez_department_settings', null, null, null, false, false, false, ['department_id', 'settings']).filter(
        el => el.department_id === this.schedule.department_id
      );
      if (symbols[0] && symbols[0].settings.row_entry_symbol) {
        this.row_entry_symbol = symbols[0].settings.row_entry_symbol;
      }
    }
  },
  watch: {
    tdWidth: {
      immediate: true,
      handler (val) {
        this.calculatePosition();
      }
    }
  },
  mounted () {
    this.calculatePosition();
    this.getRowEntrySymbol();
    window.addEventListener('resize', this.calculatePosition);
  },
  destroyed () {
    window.removeEventListener('resize', this.calculatePosition);
  }
}
